import { OverlayModule } from '@angular/cdk/overlay';
import { Component, Input, OnInit, ViewEncapsulation, inject } from '@angular/core';

import { HtmlNode, trackByProp } from '@frontend/vanilla/core';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { LabelSwitcherTrackingService } from './label-switcher-tracking.service';
import { LabelSwitcherConfig } from './label-switcher.client-config';
import { LabelSwitcherItem } from './label-switcher.models';
import { LabelSwitcherService } from './label-switcher.service';

/**
 * @stable
 */
@Component({
    imports: [OverlayModule, IconCustomComponent],
    selector: 'vn-label-switcher',
    templateUrl: 'label-switcher.html',
    styleUrls: ['../../../../../themepark/themes/whitelabel/components/label-switcher/styles.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class LabelSwitcherComponent implements OnInit {
    labelSwitcherService = inject(LabelSwitcherService);
    labelSwitcherConfig = inject(LabelSwitcherConfig);
    private trackingService = inject(LabelSwitcherTrackingService);
    private htmlNode = inject(HtmlNode);

    showLabels: boolean;

    @Input() hideFlag: boolean;

    readonly trackByName = trackByProp<LabelSwitcherItem>('name');

    ngOnInit() {
        if (this.labelSwitcherService.items().length) {
            this.htmlNode.setCssClass('label-switcher-shown', true);
        }
    }

    toggle() {
        this.showLabels = !this.showLabels;

        if (this.showLabels) {
            const positionEvent = this.labelSwitcherService.currentGeoLocationItem()?.text;
            this.trackingService.trackDropDown('Click', positionEvent || '', 'Footer State Switcher');
        }
    }

    async switchLabel(item: LabelSwitcherItem) {
        if (item.isActive) {
            return;
        }

        this.trackingService.trackDropDown(
            'Switch',
            `${this.labelSwitcherService.currentGeoLocationItem()?.text}, ${this.labelSwitcherService.currentLabelItem()?.text}`,
            item.text,
            item.url,
        );

        this.showLabels = false;
        await this.labelSwitcherService.switchLabel(item);
    }
}
